module.exports = __webpack_public_path__ + "img/WHO-logo.5ea10ad3.svg";